import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from './lib/sentry';
import App from './App';
import './styles/index.css';

// Type declaration for blank page detector (defined in index.html)
declare global {
  interface Window {
    __blankPageDetectorClear?: () => void;
  }
}

// Initialize Sentry BEFORE React renders
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Signal successful mount to blank page detector
if (typeof window.__blankPageDetectorClear === 'function') {
  window.__blankPageDetectorClear();
}
